import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-h5 text-center mb-5" }
const _hoisted_2 = { class: "font-weight-bold text-subtitle" }
const _hoisted_3 = { class: "text-body-2 text-subtitle" }
const _hoisted_4 = { class: "mt-4 mb-4 text-subtitle-2 text-subtitle text-center" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "text-body-1 font-weight-bold mt-10" }
const _hoisted_7 = { class: "text-subtitle" }

import { useI18n } from 'vue-i18n';
import { isEuVatNumber } from '@/utils/helpers';
import { useDialogsStore } from '@/store/dialogs';
import { useCompanyStore } from '@/store/companies';
import { ref } from 'vue';
import BusinessareaSelector from '@/components/shared/BusinessareaSelector.vue';
import CompanySelector from '@/components/company/CompanySelector';
import { RoutesNames } from '@/router/routesNames';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCompanyDialog',
  emits: ['companyAdded', 'companyAddSelected'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const { t } = useI18n();
const emit = __emit;

const selectedBusinessArea = ref(null);
const selectedCompany = ref(null);
const companyName = ref('');
const selectedRole = ref(null);
const checked = ref(null);
const vat = ref('');
const checkedTerms = ref(null);
const show_vat_error = ref(false);

const showResult = ref(false);

const companyStore = useCompanyStore();
const dialogsStore = useDialogsStore();

function closeDialog() {
    selectedBusinessArea.value = null;
    companyStore.companies = null;
    dialogsStore.addCompany = false;
    checked.value = null;
    checkedTerms.value = null;
    showResult.value = false;
    vat.value = null;
}

function getResultTitle() {
    if (!selectedCompany.value) {
        return t('we_are_verifying');
    } else {
        return t('request_sent_to_company_admin');
    }
}

function getResultMessage() {
    if (!selectedCompany.value) {
        return t('we_are_verifing_data');
    } else {
        return t('wait_for_the_company_administrator_to_approve');
    }
}

function canAdd() {
    let can = false;
    let isValidVat = true;
    if (!selectedCompany.value) {
        can =
            companyName.value !== '' &&
            selectedBusinessArea.value !== null &&
            vat.value &&
            vat.value !== '' &&
            !!isEuVatNumber(vat.value) &&
            checkedTerms.value == 'yes';
    } else {
        can = selectedRole.value !== null;
    }
    return can && checked.value == 'yes' && isValidVat;
}

function saveCompany() {
    if (!selectedCompany.value || !selectedCompany.value.id) {
        const companyToAdd = {
            name: companyName.value,
            businessAreaId: selectedBusinessArea.value.id,
            vatNumber: vat.value,
            acceptTermCondition: true,
        };
        emit('companyAdded', companyToAdd);
        selectedCompany.value = null;
        vat.value = null;
    } else {
        emit('companyAddSelected', {
            company: selectedCompany.value,
            role: selectedRole.value,
        });
        companyName.value = '';
    }
    showResult.value = true;
    closeDialog();
}

function chooseBusinessArea(area) {
    selectedBusinessArea.value = area;
}
function selectCompany(company) {
    selectedCompany.value = company;
}
function writeCompany(name) {
    companyName.value = name;
}
function selectRole(role) {
    selectedRole.value = role;
}
function goTo(r, newPage) {
    if (newPage) {
        const route = router.resolve({ name: r });
        window.open(route.href, '_blank');
    } else {
        router.replace({ name: r });
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    class: "font",
    modelValue: _unref(dialogsStore).addCompany,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(dialogsStore).addCompany) = $event)),
    "onClick:outside": closeDialog
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        width: "550",
        class: "pb-6 pt-1 px-1 rounded-xl"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            justify: "end",
            "align-items": "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: closeDialog,
                style: {"float":"right","right":"0px"},
                fab: "",
                absolute: "",
                icon: "",
                color: "white",
                variant: "text",
                class: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { color: "secondary" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!showResult.value)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                "no-gutters": "",
                justify: "center",
                "align-items": "center",
                class: "px-6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "px-2" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('add_company')), 1),
                        _createVNode(_unref(CompanySelector), {
                          value: selectedCompany.value,
                          onSelect: selectCompany,
                          onWrite: writeCompany,
                          onSelectRole: selectRole,
                          isOnboarding: false
                        }, null, 8, ["value"]),
                        (!selectedCompany.value || !selectedCompany.value.id)
                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                              key: 0,
                              modelValue: vat.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vat).value = $event)),
                              class: "mt-6",
                              type: 'text',
                              color: "primary",
                              label: _ctx.$t('vat'),
                              variant: "underlined",
                              placeholder: "IT12345678901",
                              rules: [(v) => !!_unref(isEuVatNumber)(v) || _ctx.$t('invalid_vat')]
                            }, null, 8, ["modelValue", "label", "rules"]))
                          : _createCommentVNode("", true),
                        (!selectedCompany.value || !selectedCompany.value.id)
                          ? (_openBlock(), _createBlock(BusinessareaSelector, {
                              key: 1,
                              type: "add",
                              onSelect: chooseBusinessArea,
                              value: selectedBusinessArea.value,
                              class: "mt-2"
                            }, null, 8, ["value"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('confirm_to_work_in_this_company')), 1),
                          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('add_company_after_validation')), 1),
                          _createVNode(_component_v_radio_group, {
                            modelValue: checked.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checked).value = $event)),
                            inline: "",
                            "hide-details": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio, {
                                value: "yes",
                                color: "primary",
                                label: "Si, lavoro per questa azienda",
                                class: "radio-text"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        (!selectedCompany.value || !selectedCompany.value.id)
                          ? (_openBlock(), _createBlock(_component_v_radio_group, {
                              key: 2,
                              modelValue: checkedTerms.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkedTerms).value = $event)),
                              inline: "",
                              class: "mt-4",
                              "hide-details": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                  value: "yes",
                                  color: "primary",
                                  class: "radio-text"
                                }, {
                                  label: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('accept')) + " ", 1),
                                    _createElementVNode("div", {
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo(_unref(RoutesNames).terms_conditions, true))),
                                      class: "text-primary cursor"
                                    }, _toDisplayString(_ctx.$t('terms_and_conditions')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_btn, {
                          rounded: "pill",
                          class: "text-uppercase mt-2",
                          color: "primary",
                          flat: "",
                          block: "",
                          disabled: !canAdd(),
                          onClick: saveCompany
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('save')), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('required_field')), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showResult.value)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                justify: "center",
                "align-items": "center",
                class: "px-6 text-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_avatar, {
                    color: "gray",
                    size: "100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "lightGray",
                        size: "50"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-alarm")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(getResultTitle()), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(getResultMessage()), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})